import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import ContactImage from '../../assets/imgs/contact_phone_img.svg';
import EmailImage from '../../assets/imgs/contact_email_img.svg';
import LocationImage from '../../assets/imgs/contact_location_img.svg';
import ImageWithDescription from '../../components/ImageWithDescription';
import { useTranslation } from 'react-i18next';

const ContactSection = styled(Box)(({ theme }) => ({
  padding: '60px 86px',
  backgroundColor: 'white',
  [theme.breakpoints.down('lg')]: {
    padding: '50px 40px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '40px 24px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 16px',
  },
}));

export default function LandingContactInfo() {
  const { t } = useTranslation();

  const contactInfo = t('informationServices.contactInfo.contacts', {
    returnObjects: true,
  }) as Array<{
    title: string;
    value: string;
  }>;

  const contactIcons = [<ContactImage />, <EmailImage />, <LocationImage />];

  return (
    <ContactSection id='contact'>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        sx={{
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 3, md: 0 },
          alignItems: { xs: 'center', md: 'stretch' },
        }}
      >
        {contactInfo.map((info, index) => (
          <ImageWithDescription
            key={index}
            icon={contactIcons[index]}
            title={info.title}
            description={info.value}
          />
        ))}
      </Box>
    </ContactSection>
  );
}
